(function () {
  function getTopBarSection() {
    var innerTopBar = document.querySelector('[id^="CustomTopBar-"]');
    if (!innerTopBar) return null;

    return innerTopBar.closest('.shopify-section') || innerTopBar;
  }

  function getHeaderSection() {
    var headerWrapper =
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header.header');

    if (!headerWrapper) return null;

    return headerWrapper.closest('.shopify-section') || headerWrapper;
  }

  function forceFixedHeader() {
    var topBar = getTopBarSection();
    var header = getHeaderSection();

    if (!header) return;

    var topBarHeight = 0;
    var headerHeight = 0;

    if (topBar) {
      topBar.classList.add('custom-force-fixed-topbar');
      topBarHeight = topBar.offsetHeight || 0;
    }

    header.classList.add('custom-force-fixed-header');
    header.style.top = topBarHeight + 'px';

    headerHeight = header.offsetHeight || 0;

    document.documentElement.style.setProperty('--custom-fixed-topbar-height', topBarHeight + 'px');
    document.documentElement.style.setProperty('--custom-fixed-header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--custom-fixed-header-total', (topBarHeight + headerHeight) + 'px');

    document.body.classList.add('custom-fixed-header-ready');
  }

  document.addEventListener('DOMContentLoaded', forceFixedHeader);
  window.addEventListener('load', forceFixedHeader);
  window.addEventListener('resize', forceFixedHeader);

  document.addEventListener('shopify:section:load', forceFixedHeader);
  document.addEventListener('shopify:section:select', forceFixedHeader);

  setTimeout(forceFixedHeader, 300);
  setTimeout(forceFixedHeader, 1000);
})();